(() => {
  /**
   * Rende le .promotion-card alte quanto la product card più alta nella pagina
   * e allinea la min-height del testo promo a quella del box info prodotto.
   *
   * Non tocca il JS delle product card che hai già.
   */

  // Selettori prodotti (uguali a quelli che usi già)
  const PRODUCT_GRID_SEL     = '.product-grid, .collection-products, .grid--products, .collection .grid';
  const PRODUCT_CARD_WRAPPER = '.product-card-wrapper.background-modal';
  const PRODUCT_INFO         = '.product-card__information__wrapper';
  const PRODUCT_INFO_VISIBLE = '.product-card__information__wrapper:not(.product-card__information__wrapper--hide)';

  // Selettori promo
  const PROMO_CARD = '.promotion-card';
  const PROMO_INNER = '.promotion-card__inner';
  const PROMO_TEXT = '.promotion-card__item-text';

  const debounce = (fn, ms = 100) => { let t; return (...a)=>{ clearTimeout(t); t=setTimeout(()=>fn(...a), ms);} };

  function measureProducts() {
    let maxCardH = 0;
    let maxInfoH = 0;

    // 1) altezza massima card prodotto
    document.querySelectorAll(PRODUCT_CARD_WRAPPER).forEach(w => {
      const h = w.offsetHeight;
      if (h > maxCardH) maxCardH = h;
    });

    // 2) altezza massima info prodotto (preferendo il visibile)
    const visibleInfos = document.querySelectorAll(PRODUCT_INFO_VISIBLE);
    if (visibleInfos.length) {
      visibleInfos.forEach(i => { maxInfoH = Math.max(maxInfoH, i.offsetHeight); });
    } else {
      document.querySelectorAll(PRODUCT_INFO).forEach(i => { maxInfoH = Math.max(maxInfoH, i.offsetHeight); });
    }

    return { maxCardH, maxInfoH };
  }

  function applyToPromos(maxCardH, maxInfoH) {
    const promos = document.querySelectorAll(PROMO_CARD);
    if (!promos.length) return;

    // Reset prima di impostare
    promos.forEach(p => { p.style.height = ''; p.style.minHeight = ''; });
    document.querySelectorAll(PROMO_INNER).forEach(el => { el.style.height = ''; });
    document.querySelectorAll(PROMO_TEXT).forEach(t => { t.style.minHeight = ''; });

    if (maxCardH > 0) {
      // card: stessa altezza delle product-card
      promos.forEach(p => { p.style.height = maxCardH + 'px'; });
      // l'inner riempie la card
      document.querySelectorAll(PROMO_INNER).forEach(el => { el.style.height = '100%'; });
    }
    if (maxInfoH > 0) {
      // testo promo: stessa "base" del box info prodotto
      document.querySelectorAll(PROMO_TEXT).forEach(t => { t.style.minHeight = maxInfoH + 'px'; });
    }
  }

  function equalizePromoToProducts() {
    const { maxCardH, maxInfoH } = measureProducts();
    if (!maxCardH && !maxInfoH) return; // se non ci sono product card in pagina, non fare nulla
    applyToPromos(maxCardH, maxInfoH);
  }

  const run = debounce(() => {
    requestAnimationFrame(() => {
      equalizePromoToProducts();
      // seconda passata per lazy/font
      setTimeout(equalizePromoToProducts, 120);
    });
  }, 60);

  // Trigger principali
  window.addEventListener('load', run, { passive: true });
  window.addEventListener('resize', run, { passive: true });
  document.addEventListener('DOMContentLoaded', run, { passive: true });

  // Font pronti
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(run);

  // Immagini/video delle product e delle promo
  document.addEventListener('DOMContentLoaded', () => {
    document
      .querySelectorAll(`${PRODUCT_GRID_SEL} img, ${PRODUCT_GRID_SEL} video, ${PROMO_CARD} img, ${PROMO_CARD} video`)
      .forEach(el => {
        const need = (el.tagName === 'IMG' && !el.complete) || (el.tagName === 'VIDEO' && !(el.readyState > 2));
        if (need) {
          el.addEventListener('load', run, { passive: true });
          el.addEventListener('loadeddata', run, { passive: true });
        }
      });
  });

  // Theme editor Shopify
  document.addEventListener('shopify:section:load', run);
  document.addEventListener('shopify:section:select', run);
})();